module.exports = __webpack_public_path__ + "static/media/i4c-product.f65daa71.svg";